export default {
  en: {
    'components.reference-display-modal.title': 'Tax office reference number',
    'components.reference-display-modal.actions.copy-to-clipboard': 'Copy to clipboard',
    'components.reference-display-modal.actions.copied-to-clipboard': 'Copied to clipboard',
  },
};
